import React, { useState, useMemo } from 'react';
import css from './FilterSidebar.module.css'; // or 'AgeFilterSection.module.css'
import SearchInput from './SearchInput';
import FilterSectionHeader from './FilterSectionHeader';

const AgeFilterSection = ({
  handleClearFilter,
  handleRadioChange,
  paramKey,
  selectedValues = [],
  isBlackBgFilter,
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  const ageRanges = [
    { value: '18,24', label: '18 - 24' },
    { value: '25,34', label: '25 - 34' },
    { value: '35,60', label: '35 - 60' },
    { value: '61,120', label: 'Above 60' },
  ];

  const selectedValueStr = Array.isArray(selectedValues)
    ? selectedValues.join(',')
    : selectedValues;

  const handleClear = () => {
    handleClearFilter(paramKey);
    setSearchTerm('');
  };

  const filteredAgeRanges = useMemo(() => {
    const term = searchTerm.trim().toLowerCase();
    const numTerm = Number(term);

    return ageRanges.filter(({ label, value }) => {
      const matchesLabel = label.toLowerCase().includes(term);

      const [min, max] = value.split(',').map(Number);
      const matchesRange = !isNaN(numTerm) && numTerm >= min && numTerm <= max;

      return matchesLabel || matchesRange;
    });
  }, [searchTerm]);

  return (
    <div className={css.ageFilterSection}>
      <FilterSectionHeader
        isBlackBgFilter={isBlackBgFilter}
        titleId="FilterCategories.age"
        handleClear={handleClear}
      />

      <SearchInput
        value={searchTerm}
        onChange={e => setSearchTerm(e.target.value)}
        placeholder="Search Age..."
      />

      <div className={css.ageScrollable}>
        {filteredAgeRanges.map(({ value, label }) => {
          const isChecked = selectedValueStr === value;

          return (
            <label key={value} className={css.ageRadioLabel}>
              <input
                type="radio"
                name={paramKey}
                value={value}
                checked={isChecked}
                onChange={e => handleRadioChange(e, paramKey)}
              />
              <span>{label}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default AgeFilterSection;
